import { Component, OnInit } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { DialogService, TreeNode, MenuItem, MessageService } from 'primeng/api';
import { Subject } from 'rxjs/Subject';
// import { CookieService } from 'ngx-cookie-service';

import { IPaginatedTable } from 'src/app/Interfaces/IPaginatedTable'
import { PaginatedTable } from 'src/app/Components/PaginatedTable/PaginatedTable'

import 'rxjs/add/operator/debounceTime';

import { environment } from 'src/environments/environment';
import { state, trigger, style, transition, animate } from '@angular/animations';

import { BaseHandbook } from 'src/app/Models/Handbooks/Base/BaseHandbook';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { HandbookDescriptor } from 'src/app/Models/Handbooks/Base/HandbookDescriptor';
import { CurrentLangPipe } from 'src/app/Pipes/CurrentLangPipe';
import { TranslatePipe } from 'src/app/Pipes/TranslatePipe';

@Component({
    selector: 'app-handbooks-list',
    templateUrl: './HandbooksList.html',
    styleUrls: [],
    providers: [DialogService, MessageService, CurrentLangPipe, TranslatePipe],
    animations: [
        trigger('rowExpansionTrigger', [
            state('void', style({
                transform: 'translateX(-10%)',
                opacity: 0
            })),
            state('active', style({
                transform: 'translateX(0)',
                opacity: 1
            })),
            transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class HandbooksListComponent extends PaginatedTable<BaseHandbook> implements OnInit, IPaginatedTable<BaseHandbook> {

    importButtons: MenuItem[] = [
        {label: 'Импорт из CSV', icon: 'fas fa-file-csv', command: () => {
            //
        }},
    ];

    HandbookId: number = 0;
    SelectedHandbook: HandbookDescriptor = null;
    
    SelectedHandbookCaption: string = '';

    HandbooksMenuItems: MenuItem[];

    getData() {
        this.isLoading = true;
        return this.http.get(`${environment.apiUrl}/api/${(this.SelectedHandbook != null) ? this.SelectedHandbook.ApiPath : 'Periodicities'}/Paged?pageNumber=${this.pageNumber}&pageSize=${this.pageSize}&filter=${this.filters}&sort=${this.sorts}`, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }

    afterPaginate() {
        this.setData(() => {
            this.isLoading = false;
        });
    }
    
    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,
        public dialogService: DialogService,
        private messageService: MessageService,
        private translatePipe: TranslatePipe,
        private currentLangPipe: CurrentLangPipe,
        // private cookieService: CookieService
    ) {
        super();

        this.router.events.forEach(x => {
            if (x instanceof NavigationEnd) {

                let lang: string = this.currentLangPipe.get()

                this.HandbookId = this.route.snapshot.params.HandbookId;
                this.SelectedHandbook = HandbookDescriptor.StaticList().filter(h => h.Id == this.HandbookId)[0];

                this.SelectedHandbookCaption = (lang == 'ru')
                    ? this.SelectedHandbook.NameRu
                    : (lang == 'kk')
                        ? this.SelectedHandbook.NameKz
                        : this.SelectedHandbook.NameEn,

                this.filtersChanged();
            }
        })
    }

    updating: boolean = false;
    Current: BaseHandbook = new BaseHandbook();
    ToCreation: BaseHandbook = new BaseHandbook();

    onRowEditInit(handbookItem: BaseHandbook) {
        this.list.map(x => x.isEditable = false)
        handbookItem.isEditable = true;
        this.Current = new BaseHandbook();
        this.Current.Id = 0 + handbookItem.Id;
        
        this.Current.NameRu = "" + (handbookItem.NameRu || '');
        this.Current.NameEn = "" + (handbookItem.NameEn || '');
        this.Current.NameKz = "" + (handbookItem.NameKz || '');
    }
    onRowEditCancel() {
        this.list.map(x => x.isEditable = false)
        this.Current = new BaseHandbook();
    }
    onRowEditSave(handbookItem: BaseHandbook) {
        this.updating = true;
        this.http.put(`${environment.apiUrl}/api/${this.SelectedHandbook.ApiPath}/Update/${this.Current.Id}`, JSON.stringify({
            Id: this.Current.Id,
            NameRu: this.Current.NameRu,
            NameKz: this.Current.NameKz,
            NameEn: this.Current.NameEn,
        }), {
            headers: {
                "Content-Type": "application/json",
            }
        }).subscribe(
            (data: BaseHandbook) => {
                this.messageService.add({
                    severity: 'success',
                    summary: this.translatePipe.transform('warnings.saved'),
                    detail: this.translatePipe.transform('warnings.handbookItemHasBeenUpdated')
                });
                this.updating = false;

                handbookItem.NameEn = "" + data.NameEn;
                handbookItem.NameKz = "" + data.NameKz;
                handbookItem.NameRu = "" + data.NameRu;

                handbookItem.isEditable = false;
            },
            err => { this.updating = false; },
            () => { this.updating = false; }
        )
    }
    createNewRow() {
        this.ToCreation;
        this.updating = true;
        this.http.post(`${environment.apiUrl}/api/${this.SelectedHandbook.ApiPath}/Create`, JSON.stringify({
            NameRu: this.ToCreation.NameRu,
            NameKz: this.ToCreation.NameKz,
            NameEn: this.ToCreation.NameEn,
        }), {
            headers: {
                "Content-Type": "application/json",
            }
        }).subscribe(
            (data: BaseHandbook) => {
                this.messageService.add({
                    severity: 'success',
                    summary: this.translatePipe.transform('warnings.saved'),
                    detail: this.translatePipe.transform('warnings.handbookItemHasBeenCreated')
                });
                this.updating = false;
                
                let _toPush = new BaseHandbook();
                _toPush.Id = 0 + data.Id;
                _toPush.NameEn = "" + this.ToCreation.NameEn;
                _toPush.NameKz = "" + this.ToCreation.NameKz;
                _toPush.NameRu = "" + this.ToCreation.NameRu;
                this.list.push(_toPush);
                this.filtersChanged();
            },
            err => { this.updating = false; },
            () => { this.updating = false; }
        )
    }

    filtersChanged() {
        this.setData(() => {
            this.isLoading = false;
        })
    }

}